/* Styles for the Compliance Requirements header bar. */
.headerContainer {
    display: flex;
    align-items: center;
    width: 100%;
    margin: 20px 0px 0px 0px;
    padding: 5px;
    border-radius: 9px;
    background-color: rgba(5, 60, 89, .06);
}
.headerRequirement {
    display: flex;
    flex: 3 1 auto;
    padding: 0px 0px 0px 10px;
}
/* The following 3 classes have specific min-widths in order to make room for the values that line up underneath them. */
.headerStatus {
    display: flex;
    justify-content: center;
    min-width: 60px;
    padding: 0px 10px 0px 0px;
}
.headerLastAssessed {
    display: flex;
    justify-content: center;
    min-width: 115px;
    padding: 0px 10px 0px 0px;
}
.headerControl {
    display: flex;
    justify-content: center;
    min-width: 200px;
    padding: 0px 10px 0px 0px;
}

/* Styles for the elements that comprise the nested list of Compliance Requirements. */
.requirementContainer {
    display: flex;
    align-items: center;
}
.indentLevel0 {
    margin: 0px 0.75rem 0px 0px;
}
.indentLevel1 {
    margin: 0px 0.75rem 0px 25px;
}
.indentLevel2 {
    margin: 0px 0.75rem 0px 50px;
}
.indentLevel3 {
    margin: 0px 0.75rem 0px 75px;
}
.indentLevel4 {
    margin: 0px 0.75rem 0px 100px;
}
.arrowContainer {
    padding: .375rem .75rem .375rem .75rem;
}
.arrowIconHidden {
    opacity: 0;
}
.requirementIdentifierContainer {
    padding: 0px 12px 0px 0px;
    white-space: nowrap;
}
.requirementTextContainer {
    display: flex;
    flex: 3 1 auto;
    padding: 5px 0px 5px 0px;
}

/* The following 3 classes have specific min-widths in order to align them to their headers. */
.requirementStatusContainer {
    display: flex;
    min-width: 60px;
    justify-content: center;
}
.requirementLastAssessedContainer {
    display: flex;
    min-width: 115px;
    justify-content: center;
}
.requirementControlContainer {
    display: flex;
    min-width: 200px;
    justify-content: center;
    max-width: 200px;
    padding: 0px 5px;
    text-align: center;
}

.hrModifier {
    margin: 0px;
    border: 1px solid var(--hps-blue);
    opacity: 0.06;
}